import PropTypes from 'prop-types';
import Button from 'sd-ui/dist/commonjs/components/Button/Button';
import Icon from '../../icon';

export default function BackToReadingButton({ onClick }) {
  return (
    <Button
      className="back-to-reading-button"
      icon={<Icon.Rewind />}
      iconPlacement="left"
      id="back-to-reading-button"
      onClick={onClick}
    >
      Back to reading
    </Button>
  );
}

BackToReadingButton.propTypes = {
  onClick: PropTypes.func,
};

BackToReadingButton.defaultProps = {
  onClick: () => {},
};
